import { Line } from 'react-chartjs-2'
import { ChartProvider, LoadingFit, PageHeader } from '../../share/Components'
import classes from './ManagementDashboard.module.scss'
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import DateFilter from './Items/DateFilter'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { useEffect, useState } from 'react'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'

interface dataset {
  label: string
  data: Array<number>
  borderColor: string
  backgroundColor: string
}
const InsuranceSharePaymentsReport = () => {
  const [labels, setLabels] = useState<Array<string>>([])
  const [values, setValues] = useState<Array<dataset>>([])
  const color = [
    {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    {
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
    {
      borderColor: 'rgb(153, 62, 135)',
      backgroundColor: 'rgba(153, 62, 135, 0.5)',
    },
    {
      borderColor: 'rgb(237, 223, 27)',
      backgroundColor: 'rgba(237, 223, 27, 0.5)',
    },
    {
      borderColor: 'rgb(111, 111, 111)',
      backgroundColor: 'rgba(111, 111, 111, 0.5)',
    },
  ]
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dateFilter = useSelector<ReducerType, DateFilterViewModel>(
    (state) => state.reducerDateFilter
  )
  const dataSetsData = new Array<dataset>()
  const { isLoading, reFetch } = useFetch<
    Array<InsuranceSharePaymentsViewModel>,
    unknown,
    { to?: Date; from?: Date }
  >({
    request: RaytebRequests.Management_GetInsuranceSharePayments_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      // Create a Set to store unique date values
      const uniqueDates = new Set<Date>()

      // Iterate through the data and add unique date values to the Set
      data.forEach((group, index) => {
        const dataset = {
          label: group.title || '', // Use an empty string if 'title' is not defined
          data: group.data?.map((item) => item.value) ?? [0], // Extract values from 'data'
          borderColor: color[index]?.borderColor ?? 'rgb(255, 99, 132)', // Specify the border color as needed
          backgroundColor:
            color[index]?.backgroundColor ?? 'rgba(255, 99, 132, 0.5)', // Specify the background color as needed
        }
        group.data?.forEach((item) => {
          uniqueDates.add(new Date(item.date)) // Using ISO string to ensure uniqueness
        })
        dataSetsData.push(dataset)
      })

      // Convert the Set of unique dates back to an array
      const uniqueDatesArray = Array.from(uniqueDates, (date) =>
        date.toShamsi()
      )

      setLabels(uniqueDatesArray)
      setValues(dataSetsData)
    },
  })
  useEffect(() => {
    reFetch(null, {
      from: dateFilter?.from,
      to: dateFilter?.to,
    })
  }, [dateFilter]) // eslint-disable-line react-hooks/exhaustive-deps

  const data = {
    labels,
    datasets: values,
  }
  return (
    <>
      <LoadingFit isLoading={isLoading}></LoadingFit>
      <PageHeader title='داشبورد مدیریتی / سهم سازمان' />
      {!isLoading && values.length > 0 && (
        <div className={classes['report-dashboard']}>
          <div className={classes['filters']}>
            <DateFilter />
          </div>
          <div className={classes['items']}>
            <ChartProvider
              listChart={[
                CategoryScale,
                LinearScale,
                PointElement,
                LineElement,
                Title,
                Tooltip,
                Legend,
              ]}
            >
              <Line data={data} />
            </ChartProvider>
          </div>
        </div>
      )}
    </>
  )
}
export default InsuranceSharePaymentsReport
